import ContentModel from '../content/index.model.js';
import RuleModel from '../rule/index.model.js';
import FilterModel from '../searchFilter/index.model.js';
import RecipeModel from './recipe.model.js';
const model = {
    name: 'Recommendations',
    properties: {
        content: { type: 'model', model: ContentModel },
        filter: { type: 'model', model: FilterModel },
        recipe: { type: 'model', model: RecipeModel },
        limit: {},
        rule: { type: 'model', model: RuleModel },
    },
};
export default model;
